import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import SmsIcon from '@mui/icons-material/Sms';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { sendSMS } from '../../../../utils/ServicesAPIUtils';
import { getArrivalList, getMsgStatuslList } from '../../../../utils/campaignAPIUtils';

const ArrivalList = (props) => {
  const { selectedHotel, page, rowsPerPage, onsetRowsPerPage, onsetPage } = props;
  const [loading, setLoading] = useState(true);
  const [statusList, setStatusList] = useState([]);
  const [arrivalList, setArrivalList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [currDate, setCurrDate] = useState(moment().format('YYYY-MM-DD'));
  const [dateCount, setDateCount] = useState(0);
  const [tempSearchText, setTempSearchText] = useState('');
  const [searchButton, setSearchButton] = useState(true);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const sendGuestSMS = async (item) => {
    let guestId, resId;
    if (item) {
      guestId = item.lastName;
      resId = item.confirmationId;
    } else if (selectedCount > 0) {
      const selectedList = arrivalList.filter((guest) => guest.isChecked);
      guestId = selectedList.map((guest) => guest.lastName).toString();
      resId = selectedList.map((guest) => guest.confirmationId).toString();
    }

    if (guestId && resId) {
      try {
        await sendSMS('NA', guestId, selectedHotel, '', resId);
        notificationManager(
          'success',
          `${
            selectedCount > 0 && !item
              ? `SMS Sent Successfully to ${selectedCount} Guests`
              : `SMS Sent Successfully to the guest ${item.firstName} ${item.lastName}`
          }`,
        );
      } catch (e) {
        notificationManager(
          'danger',
          `${selectedCount > 0 ? 'Messages ' : 'Message'} sending failed`,
        );
      }
      fetchStatuslist();
    } else {
      notificationManager('danger', 'Guest not selected');
    }
  };

  const fetchStatuslist = async () => {
    const listRes = await getMsgStatuslList(selectedHotel);
    setStatusList(listRes.data.getChatMsgStatus.status);
  };

  const fetchList = async (hotelId, date) => {
    setLoading(true);
    try {
      setSelectAll(false);
      const res = await getArrivalList(hotelId, date);
      const checkins = res.data.getFutureBookingDashboard;

      if (checkins && checkins.arrivalList && checkins.arrivalList.length > 0) {
        setOriginalList(
          checkins.arrivalList.map((arrival) => {
            return {
              isChecked: false,
              firstName: arrival.details.contactPerson.firstName,
              lastName: arrival.details.contactPerson.lastName,
              phoneNumber: arrival.details.contactPerson.phoneNumber,
              arrivalDate: arrival.details.checkInDate
                ? moment(arrival.details.checkInDate, 'YYYY-MM-DD').format('Do MMM YYYY')
                : 'N/A',
              confirmationId: arrival.confirmationId,
              status: 'notsent',
            };
          }),
        );
      } else {
        setOriginalList([]);
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      return false;
    }
  };

  useEffect(() => {
    if (selectedHotel) {
      setLoading(true);
      setDateCount(0);
      const nowDate = moment().format('YYYY-MM-DD');
      fetchStatuslist();
      setCurrDate(nowDate);
      fetchList(selectedHotel, nowDate);
    }
  }, [selectedHotel]);

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    const filteredRows = originalList.filter((item) => {
      return (
        item.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.lastName.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    onsetPage(0);
    setArrivalList(filteredRows);
  };
  useEffect(() => {
    setOriginalList(
      originalList.map((item) => {
        return item.phoneNumber ? { ...item, isChecked: selectAll } : { ...item };
      }),
    );
  }, [selectAll]);

  useEffect(() => {
    if (originalList?.length) {
      const isAllArrivalListSelected = originalList?.every((arrival) => arrival?.isChecked);
      setSelectAll(isAllArrivalListSelected);
    }
  }, [originalList]);

  useEffect(() => {
    if (originalList.length) {
      let filteredRows;

      if (statusList.length > 0) {
        filteredRows = originalList.map((item) => {
          const smsStatus = statusList.find((st) => st.reservationId === item.confirmationId);
          return smsStatus ? { ...item, status: smsStatus.status ? 'sent' : 'error' } : { ...item };
        });
      } else {
        filteredRows = originalList;
      }

      setArrivalList(filteredRows);
      setTempSearchText('');
      setSearchButton(true);
      setSelectedCount(filteredRows?.filter((item) => item?.isChecked)?.length);
    } else {
      setArrivalList([]);
    }
  }, [originalList, statusList]);

  const updateGuestItem = (item, compareField, updateField, value) => {
    setOriginalList(
      originalList.map((guest) => {
        return item[compareField] === guest[compareField]
          ? { ...guest, [updateField]: value }
          : { ...guest };
      }),
    );
  };

  const handleDateChange = (val) => {
    const newCount = dateCount + val * 1;
    if (newCount > -2 && newCount < 2) {
      setDateCount(newCount);
      const newCurrDate = moment().add(newCount, 'days').format('YYYY-MM-DD');
      setCurrDate(newCurrDate);
      fetchList(selectedHotel, newCurrDate);
    }
  };

  return (
    <div className='mt-4'>
      <div className='row mx-2 d-flex'>
        <div className='col-12 col-lg-4'>
          <TextField
            className='w-75'
            onChange={(e) => {
              setSearchText(e.target.value);
              setSearchButton(e?.target?.value ? false : true);
            }}
            label='Search'
            value={tempSearchText}
            InputProps={
              searchButton && {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }
          />
        </div>
        <div className='col-12 col-lg-4 pt-3 pt-lg-0 d-flex justify-content-center'>
          <div className='d-flex align-items-center justify-content-between w-100 px-5'>
            {dateCount > -1 ? (
              <ArrowBackIosIcon className='cursor-pointer' onClick={() => handleDateChange(-1)} />
            ) : (
              <div></div>
            )}
            <div className='bolder-text'>
              {moment(currDate, 'YYYY-MM-DD').format('Do MMM YYYY')}
            </div>
            {dateCount < 1 ? (
              <ArrowForwardIosIcon className='cursor-pointer' onClick={() => handleDateChange(1)} />
            ) : (
              <div></div>
            )}
          </div>
        </div>
        <div className='col-md-4 d-flex justify-content-end'>
          {selectedCount > 0 && (
            <div className='d-flex align-items-center'>
              <div className='me-4'>
                {`${selectedCount} ${selectedCount === 1 ? 'User' : 'Users'} Selected`}
              </div>
              <Button
                variant='contained'
                color='primary'
                size='large'
                onClick={() => sendGuestSMS(null)}
              >
                Send SMS
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className='row mx-2 d-flex mt-2'>
        {loading ? (
          <div className='pt-4 col-md-12 pb-4'>
            <LinearProgressBar />
          </div>
        ) : (
          arrivalList && (
            <TableContainer className='arrival-list-table mt-2'>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow className='border-white pointer'>
                    <TableCell>
                      {dateCount === 0 && (
                        <Checkbox
                          checked={selectAll}
                          className='check-box'
                          onChange={(e) => {
                            setSelectAll(!selectAll);
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell className='w-30'>First Name</TableCell>
                    <TableCell className='w-30'>Last Name</TableCell>
                    <TableCell className='w-20'>Phone No</TableCell>
                    <TableCell className='w-20'>Arrival Date</TableCell>
                    <TableCell align='right'>Send SMS</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rowsPerPage > 0
                    ? arrivalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : arrivalList
                  ).map((item, i) => (
                    <TableRow key={item.confirmationId}>
                      <TableCell>
                        {Boolean(item.phoneNumber) && dateCount === 0 && (
                          <Checkbox
                            checked={item.isChecked}
                            className='check-box'
                            onChange={(e) => {
                              updateGuestItem(
                                item,
                                'confirmationId',
                                'isChecked',
                                e.target.checked,
                              );
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>{item.firstName}</TableCell>
                      <TableCell>{item.lastName}</TableCell>
                      <TableCell>{item.phoneNumber}</TableCell>
                      <TableCell>{item?.arrivalDate}</TableCell>

                      <TableCell align='right'>
                        {item.status === 'notsent' ? (
                          dateCount === 0 && (
                            <IconButton
                              variant='outlined'
                              color='primary'
                              aria-label='sms'
                              disabled={Boolean(!item.phoneNumber)}
                              onClick={(e) => sendGuestSMS(item)}
                            >
                              <SmsIcon />
                            </IconButton>
                          )
                        ) : (
                          <div className='d-flex align-items-center'>
                            {item.status === 'sent' && <CheckCircleIcon className='text-green' />}

                            {item.status === 'error' && <CancelIcon className='text-red' />}

                            {dateCount === 0 && (
                              <IconButton
                                className='yellow-btn'
                                aria-label='sms'
                                disabled={Boolean(!item.phoneNumber)}
                                onClick={(e) => sendGuestSMS(item)}
                              >
                                <ReplayCircleFilledIcon />
                              </IconButton>
                            )}
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={arrivalList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};

export default ArrivalList;
